import { decodeJwt } from "@/utils/decode-jwt.js";

const state = {
  isThermal: false,
  isBobbieContext: false,
  bobbieToken: null,
  isInIFrameContext: false,
};

const actions = {};

const mutations = {
  setIsThermal(state, value) {
    state.isThermal = value;
  },
  setIsBobbieContext(state, value) {
    state.isBobbieContext = value;
  },
  setBobbieToken(state, token) {
    state.bobbieToken = token;
  },
  setIsInIFrameContext(state, value) {
    state.isInIFrameContext = value;
  },
};

export default {
  state,
  actions,
  mutations,
};
